"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#EE8208",
    d: "M12 10.557c.629 0 1.141-.512 1.141-1.141S12.629 8.275 12 8.275s-1.141.512-1.141 1.141.512 1.141 1.141 1.141"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#EE8208",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m0 2.909c1.521 0 2.757 1.237 2.757 2.757S13.521 12.172 12 12.172c-1.52 0-2.757-1.236-2.757-2.756S10.48 6.659 12 6.659m2.716 7.099a5.2 5.2 0 0 1-1.601.663l1.541 1.541a.806.806 0 1 1-1.141 1.142L12 15.59l-1.514 1.514a.808.808 0 0 1-1.143-1.142l1.541-1.541a5.2 5.2 0 0 1-1.601-.663.807.807 0 0 1 .86-1.367 3.5 3.5 0 0 0 3.712 0 .807.807 0 0 1 .861 1.367"
  })]
}), 'OdnoklassnikiRing');
//# sourceMappingURL=index.js.map